import { Injectable } from '@angular/core';
import { CallStoreService } from '../call-store/call-store.service';
import { AppConstants } from 'src/app/app-constants';

@Injectable({
  providedIn: 'root',
})
export class CallValidationService {
  constructor(private callStore: CallStoreService) {}

  /**
   * Validates if the call is in an active state
   * Checks if the current view is practice view and the call has not ended
   * @returns true if call is active, false otherwise
   */
  isCallActive(): boolean {
    const currentView = this.callStore.getCurrentView();
    const isPracticeView = currentView == AppConstants.VIEW_PRACTICE;

    if (!isPracticeView) {
      console.log(
        `CALL STATE ::: Not in practice view, currentView: ${currentView}`
      );
      return false;
    }

    const isCallEnded = this.callStore.getDisplayPostCall();
    if (isCallEnded) {
      console.log(`CALL STATE ::: Call has ended`);
      return false;
    }

    return true;
  }
}
